import { Component, OnInit } from '@angular/core';
import {BackendApiService} from '../services/backend-api.service';
import {ActivatedRoute, Router,NavigationEnd} from '@angular/router';


import _ from "lodash";
import * as $ from 'jquery';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  
  constructor(private router: Router,
              private backendApiService: BackendApiService,
              ) { }
  accessToken : any;
  message : any;
  ngOnInit(): void {
    let urlArry = this.router.url.split("/");
    if(urlArry.length>0){
      let urlName = urlArry[1];
      if(urlName == "badlaorder"){
        $("#Settlem-ent").addClass("nav-link bag-3 active")
      }else if(urlName == "livebadla"){
        $("#line-tab").addClass("nav-link bag-2 active")
      }else{
        $("#fancy-tab").addClass("nav-link bag-1 active")
      }
    }
    let accessTokenData = localStorage.getItem('accessToken');
    if(accessTokenData){
      this.accessToken = accessTokenData;  
    }

    let data = {};
    this.backendApiService.getMessage(data).subscribe(response => {
      if(response['status'] == true){
        this.message = response['data']['0']['messageDetail'];
      }else{
        this.message = "Welcome";
      }
    })
  }

  

}
